import React from "react";
import { useState } from "react";
import { writeContract, getNetwork } from '@wagmi/core'
import { getFirstEditionNFTAddress } from '../../constants/addressBook'
import firstEditionNFTABI from '../../abis/firstEditionNFTABI'

export const SetURIFirstEditionNFT: React.FC = () => {
  const [articleId, setArticleId] = useState("");
  const [Uri, setUri] = useState("ipfs://");

  return (
    <div>
      <label>Set a new URI for an article
      <form>
        <label>Article Id
          <input
            type="text" 
            value={articleId}
            onChange={(e) => setArticleId(e.target.value)}
          />
        </label>

        <label>Uri
          <input
            type="text" 
            value={Uri}
            onChange={(e) => setUri(e.target.value)}
          />
        </label>
      </form>
      <button onClick={async () => {
        const network = await getNetwork()
        console.log(network.chain?.name)
        const articleNFTAddress = getFirstEditionNFTAddress(network.chain?.name)
        writeContract({
          address: articleNFTAddress,
          abi: firstEditionNFTABI,
          functionName: "setURI",
          args: [BigInt(articleId), Uri]
        })
      }}>Submit</button>
      </label>
      <br/>
      <br/>
    </div>
  )
}